<template>
  <div>
    <confirm-box :dialog="dialog" @confirmed="deleteItem" @cancel="cancel" />
    <v-expansion-panels accordion>
      <v-expansion-panel>
        <v-expansion-panel-header class="white--text" color="purple accent-4"
          >View Volunteer Training</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <v-data-table
            class="my-tb"
            :headers="headers"
            :items="trainingDataHandler"
            :loading="loading"
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            mobile-breakpoint="800"
            :page.sync="page"
            item-key="id"
            hide-default-footer
            hide-default-header
          >
            <template v-slot:top>
              <v-row class="mt-2">
                <ul>
                  <li v-for="item in trainingTypes" v-bind:key="item.id">
                    {{ item.name }} = {{ item.descripton }}
                  </li>
                </ul>
              </v-row>
              <v-row class="mt-4">
                <v-col cols="12" sm="3" lg="3">
                  <v-combobox
                    v-model="trType"
                    :error-messages="typeValidation"
                    placeholder="choose Way of Training"
                    outlined
                    dense
                    item-text="name"
                    item-value="id"
                    :items="trainingTypes"
                  ></v-combobox>
                </v-col>
                <v-col cols="12" sm="3" lg="2">
                  <v-combobox
                    v-model="type"
                    :error-messages="trTypeValidation"
                    placeholder="choose type"
                    outlined
                    dense
                    item-text="name"
                    item-value="id"
                    :items="types"
                  ></v-combobox>
                </v-col>
                <v-col sm="12" lg="3">
                  <date-picker
                    @clearDate="date = null"
                    placeholder="choose Training date"
                    :date="date"
                    v-model="date"
                  />
                </v-col>
                <v-col cols="12" lg="3" sm="12">
                  <v-text-field
                    v-model="training_duration"
                    placeholder="training duration"
                    type="number"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="1">
                  <v-btn
                    @click.prevent="createVolTraining"
                    depressed
                    dark
                    color="purple accent-4"
                    class="mt-1"
                  >
                    Save
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="d-flex justify-content-end"> </v-row>
            </template>

            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th
                    v-for="header in headers"
                    :key="header.text"
                    class="header--text"
                  >
                    {{ header.text }}
                  </th>
                </tr>
              </thead>
            </template>
            <template v-slot:item="{ index, item }">
              <tr>
                <td>{{ index + 1 }}</td>
                <td>{{ item.date }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.type == 1 ? "In-person" : "Virtual" }}</td>
                <td>{{ item.training_duration }}</td>
                <td>
                  <div class="mr-2">
                    <v-btn
                      @click="openConfrimBox(item)"
                      icon
                      color="red lighten-1"
                      class="white--text"
                      depressed
                    >
                      <v-icon>mdi-delete-outline</v-icon>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
          <div class="text-center py-3">
            <v-pagination
              color="purple accent-4"
              v-model="page"
              :length="pageCount"
            ></v-pagination>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import ConfirmBox from "@/components/notification/ConfirmBox";
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../../mixins/ValidationMixin";
import { mapState } from "vuex";
import DatePicker from "@/components/common/DatePicker.vue";

export default {
  mixins: [ValidationMixin],
  props: {
    volunteer_id: String,
  },
  components: {
    ConfirmBox,
    DatePicker,
  },
  validations: {
    type: {
      required,
    },
    trType: {
      required,
    },
    date: {
      required,
    },
  },
  data: () => ({
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    item: {},
    dialog: false,
    headers: [
      { text: "No", value: "no", width: 200 },
      { text: "Date", value: "date" },
      {
        text: "Way Of Training",
        value: "training_type_id",
      },
      { text: "Training Type", value: "type" },
      { text: "Training Duration", value: "training_duration" },
      { text: "Actions", value: "actions" },
    ],
    type: null,
    date: null,
    trType: null,
    trainingTypes: [
      {
        id: 1,
        name: "On Job",
        descripton:
          "Record as On Job if volunteer received One day On-site training given by FO",
      },
      {
        id: 2,
        name: "New",
        descripton:
          "Record as New if volunteer received 2 to 3 days formal training and hasn't received any formal training previously ",
      },
      {
        id: 3,
        name: "Refresher",
        descripton:
          "Record as Refresher if volunteer received 2 to 3 days formal training and has received formal training previously",
      },
    ],
    types: [
      { id: 1, name: "In-person" },
      { id: 2, name: "Virtual" },
    ],
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
    ...mapState("Training", ["trainingData"]),
    trainingDataHandler() {
      const trainingData = this.trainingData.map((data) => {
        const trainingTypes = this.trainingTypes.find((type) => {
          return data.training_type_id == type.id;
        });
        data.name = trainingTypes.name;
        data.value = false;
        return data;
      });
      return trainingData;
    },
    typeValidation() {
      return this.handleFieldErrors(this.$v.type);
    },
    trTypeValidation() {
      return this.handleFieldErrors(this.$v.trType);
    },
    dateValidation() {
      return this.handleFieldErrors(this.$v.date);
    },
  },
  methods: {
    createVolTraining() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {
          training_type_id: this.trType.id,
          date: this.date,
          volunteer_id: this.volunteer_id,
          type: this.type.id,
          training_duration: this.training_duration,
        };
        this.$store.dispatch("Training/createVolTraining", data);
      }
    },
    openConfrimBox(item) {
      this.item = item;
      this.dialog = !this.dialog;
    },
    deleteItem() {
      let data = {
        id: this.item.id,
      };
      this.$store
        .dispatch("Training/deleteVolTraining", data)
        .then((isPass) => {
          if (isPass) this.dialog = !this.dialog;
        });
    },
    cancel() {
      this.dialog = !this.dialog;
    },
  },
  mounted() {
    this.$store.dispatch("Training/getVolTraningData", this.volunteer_id);
  },
};
</script>

<style scoped>
.header--text {
  /* font-size: 15px !important; */
  color: grey !important;
  padding: 0px !important;
}
.v-expansion-panel:before {
  box-shadow: var(--box-shadow) !important;
}

.theme--light.v-expansion-panels
  .v-expansion-panel-header
  .v-expansion-panel-header__icon
  .v-icon {
  color: #fff !important;
}
table {
  table-layout: fixed !important;
  overflow-y: scroll;
}
</style>
